import { FiArrowLeft, FiArrowLeftCircle, FiPlay } from 'react-icons/fi';
import { IoEye, IoEyeOff, IoGameControllerOutline } from 'react-icons/io5';
import { LuCircleDollarSign } from 'react-icons/lu';
import { FaRegCaretSquareRight, FaUserTie } from 'react-icons/fa';
import { CiUser } from 'react-icons/ci';
import { FaBangladeshiTakaSign } from 'react-icons/fa6';
import { IoChevronBackCircleOutline } from 'react-icons/io5';
import { FaUpload } from 'react-icons/fa6';
import { TbFileTypeCsv } from 'react-icons/tb';
import { PiFilePdfBold, PiMicrosoftExcelLogo } from 'react-icons/pi';
import { TbRefresh } from 'react-icons/tb';

export const reactIcons = {
  circleArrow: FiArrowLeftCircle,
  play: FiPlay,
  user: FaUserTie,
  eye: IoEye,
  eyeof: IoEyeOff,
  game: IoGameControllerOutline,
  casino: LuCircleDollarSign,
  squareBack: FaRegCaretSquareRight,
  user2: CiUser,
  taka: FaBangladeshiTakaSign,
  circleBack: IoChevronBackCircleOutline,
  upload: FaUpload,
  csv: TbFileTypeCsv,
  pdf: PiFilePdfBold,
  excel: PiMicrosoftExcelLogo,
  refresh: TbRefresh,
  arrowLeft: FiArrowLeft,
} as const;
